import { request } from "@esri/arcgis-rest-request";
import { determineOwner } from './helpers';
import { getPortalUrl } from "../util/get-portal-url";
/**
 * ```js
 * import { exportItem } from "@esri/arcgis-rest-portal";
 * //
 * exportItem({
 *      id: '3daf',
 *      owner: 'geemike',
 *      exportFormat: 'CSV',
 *      exportParameters: {
 *        layers: [
 *          { id: 0 },
 *          { id: 1, where: 'POP1999 > 100000' }
 *        ]
 *      },
 *      authentication,
 *    })
 * ```
 * Exports an item from the portal. See the [REST Documentation](https://developers.arcgis.com/rest/users-groups-and-items/export-item.htm) for more information.
 *
 * @param requestOptions - Options for the request
 * @returns A Promise<IExportItemResponse>
 */
export var exportItem = function (requestOptions) {
    var authentication = requestOptions.authentication, itemId = requestOptions.id, title = requestOptions.title, exportFormat = requestOptions.exportFormat, exportParameters = requestOptions.exportParameters;
    return determineOwner(requestOptions)
        .then(function (owner) { return getPortalUrl(requestOptions) + "/content/users/" + owner + "/export"; })
        .then(function (url) { return request(url, {
        httpMethod: 'POST',
        authentication: authentication,
        params: {
            itemId: itemId,
            title: title,
            exportFormat: exportFormat,
            exportParameters: exportParameters
        }
    }); });
};
//# sourceMappingURL=export.js.map